var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.getCrossWithNames.length > 0
    ? _c("div", [
        _c("span", { staticClass: "h4" }, [
          _vm._v(_vm._s(_vm.$translate("Bigtex5::Template.singleFarbeMore")))
        ]),
        _vm._v(" "),
        _vm.matchingSize
          ? _c("div", { staticClass: "matching-size-hint small my-2" }, [
              _c("i", { staticClass: "fa fa-user-circle-o" }),
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.$translate("Bigtex5::Template.crossItemMatchingSize", {
                      size: _vm.matchingSize
                    })
                  ) +
                  "\n  "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex flex-wrap" },
          [
            _vm._l(_vm.getCrossWithNames.slice(0, _vm.itemsToShow), function(
              item,
              index
            ) {
              return [
                _c(
                  "div",
                  {
                    key: item.data.item.id,
                    staticClass: "mb-2",
                    on: {
                      mouseenter: function($event) {
                        return _vm.hoverColor(item.color)
                      },
                      mouseleave: function($event) {
                        return _vm.resetHoverColor()
                      }
                    }
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "cross-image",
                        attrs: {
                          "aria-label": "cross-image",
                          href:
                            "/" +
                            item.data.texts.urlPath +
                            "/a-" +
                            item.data.item.id +
                            "/"
                        }
                      },
                      [
                        item.data.item.storeSpecial ||
                        item.data.variation.bundleType === "bundle" ||
                        item.data.item.itemType === "set"
                          ? _c("item-store-special", {
                              attrs: {
                                "store-special": item.data.item.storeSpecial,
                                "recommended-retail-price":
                                  item.data.prices.rrp,
                                "variation-retail-price":
                                  item.data.prices.default,
                                "special-offer-price":
                                  item.data.prices.specialOffer,
                                "decimal-count": 0,
                                "bundle-type": item.data.variation.bundleType,
                                "item-type": item.data.item.itemType
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "img-fluid",
                          attrs: {
                            src: item.data.images.all[0].urlSecondPreview,
                            alt: item.data.texts.name1,
                            title: item.data.texts.name1
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]
            })
          ],
          2
        ),
        _vm._v(" "),
        _c("div", [
          _vm.itemsToShow < _vm.getCrossWithNames.length
            ? _c(
                "button",
                { staticClass: "btn btn-primary", on: { click: _vm.showMore } },
                [_vm._v("\n      Alle Farben anzeigen\n    ")]
              )
            : _vm._e()
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }